import bindAllOfThis from 'src/utils/BindThisHelper';
import { TiledGameObject } from 'src/games/shared/phaserHelpers/HandyTypes';
import { Animal, Habitat, Food } from '../objects/Animal';
import { EndGameScene } from './EndGameScene';

export class MainScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    map: Phaser.Tilemaps.Tilemap;

    animals: Animal[];
    food: Food[];

    constructor() {
        super({
            key: "MainScene"
        });
        bindAllOfThis(this, MainScene.prototype);
    }

    preload(): void {
        this.load.image("pixel", require("/src/assets/qci/sprites/pixel.png"));
        this.load.tilemapTiledJSON('map', require("/src/assets/qci/maps/zoo.json"));
        this.load.image('background', require('/src/assets/qci/backgrounds/ki_background.png'));
        this.load.atlas("assets", require("src/assets/qci/atlas/gameZoo.png"), require("src/assets/qci/atlas/gameZoo.json"));
    }

    initialize(): void {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'map' });
        this.animals = [];
        this.food = [];
    }

    create(): void {
        this.initialize();
        var background = this.add.image(0, 0, "background").setOrigin(0).setDepth(0);
        this.createHabitats();
        this.createAnimals();
        this.createFoods();
        this.registerEvents();
    }

    createHabitats() {
        this.map.getObjectLayer("Habitats").objects.forEach((ob: TiledGameObject) => {
            var habitat = new Habitat(this, ob);
            var animal = this.map.getObjectLayer("AnimalPlaced").objects.find((ob: TiledGameObject) => ob.properties["id"] === habitat.id) as TiledGameObject;
            var food = this.map.getObjectLayer("FoodPlaced").objects.find((ob: TiledGameObject) => ob.properties["id"] === habitat.id) as TiledGameObject;
            habitat.animalPoint.x = animal.x + animal.width / 2;
            habitat.animalPoint.y = animal.y + animal.height / 2;
            habitat.foodPoint.x = food.x + food.width / 2;
            habitat.foodPoint.y = food.y + food.height / 2;
        });
    }

    createAnimals() {
        this.map.getObjectLayer("Animals").objects.forEach((ob: TiledGameObject) => {
            var animal = new Animal(this, ob);
            this.animals.push(animal);
        });
    }

    createFoods() {
        this.map.getObjectLayer("Food").objects.forEach((ob: TiledGameObject) => {
            var food = new Food(this, ob);
            this.food.push(food);
        });
    }

    registerEvents(): void {
        this.input.dragDistanceThreshold = 10;

        this.input.on('dragstart', (pointer: Phaser.Input.Pointer, gameObject: Animal | Food) => {
            this.children.bringToTop(gameObject);
            pointer.x = gameObject.x;
            pointer.y = gameObject.y;
        });

        this.input.on('drag', (pointer: Phaser.Input.Pointer, gameObject: Animal | Food, dragX: number, dragY: number) => {
            gameObject.x = pointer.x;
            gameObject.y = pointer.y;
        });

        this.input.on('dragend', (pointer: Phaser.Input.Pointer, gameObject: Animal | Food, dropped: boolean) => {
            if (!dropped) {
                // Put back
                gameObject.x = gameObject.input.dragStartX;
                gameObject.y = gameObject.input.dragStartY;
            }
        });

        this.input.on('drop', (pointer: Phaser.Input.Pointer, gameObject: Animal | Food, habitat: Habitat) => {
            this.drop(gameObject, habitat);
        });

    }

    drop(gameObject: Animal | Food, habitat: Habitat) {
        if (gameObject.id === habitat.id) {
            gameObject.isInHabitat = true;
            gameObject.input.enabled = false;
            gameObject.putInHabitat(habitat);
        }
        else {
            gameObject.isInHabitat = false;
            // Put back
            gameObject.x = gameObject.input.dragStartX;
            gameObject.y = gameObject.input.dragStartY;
        }

        this.isGameOver();
    }

    isGameOver(): boolean {
        var animal: Animal;

        for (animal of this.animals) {
            if (!animal.isInHabitat) {
                return false;
            }
        }

        var food: Food;
        for (food of this.food) {
            if (!food.isInHabitat) {
                return false;
            }
        }

        this.input.enabled = false;

        // Wait a second and then end the game
        setTimeout(() => {
            this.scene.add("EndGameScene", EndGameScene, true);
            this.scene.remove(this);
        }, 1000);

        return true;
    }
}



// WEBPACK FOOTER //
// ./src/games/ZooGame/scenes/MainScene.ts